import React from 'react';
import Header from './Header';
import Hero from './Hero';
import FAQ from './FAQ';
import Download from './Download';
import Footer from './Footer';

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <FAQ />
      <Download />
      <Footer />
    </>
  );
};

export default Home;
